import { render, staticRenderFns } from "./DeathTreatmentSequence.vue?vue&type=template&id=35cdc6a0&scoped=true&"
import script from "./DeathTreatmentSequence.vue?vue&type=script&lang=js&"
export * from "./DeathTreatmentSequence.vue?vue&type=script&lang=js&"
import style0 from "./DeathTreatmentSequence.vue?vue&type=style&index=0&id=35cdc6a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cdc6a0",
  null
  
)

export default component.exports